"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.telephone = void 0;
var telephone = {
  "viewBox": "0 0 512 512",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"
    },
    "children": []
  }, {
    "name": "path",
    "attribs": {
      "d": "M327.125,383.969c5.703,0.016,56.875-37.828,56.875-42.656s-57.266-40.906-62.219-40.906s-21.578,19.938-26.062,22.156\r\n\tc-4.5,2.219-32.5,1.422-63.703-29.781c-31.219-31.188-41.875-67.109-41.875-72.75s26.031-23.062,26.75-27.156\r\n\tS182.578,128,176.891,128S128,180.5,128,184.875s3.953,60.656,75.219,131.906S321.422,383.938,327.125,383.969z"
    },
    "children": []
  }]
};
exports.telephone = telephone;